import { withStylePrefix } from '../../common/withStylePrefix';
import { DataTableRowComponent, dataTableRowComponentTemplate } from './DataTableRow';
import styles from './DataTableRow.styles.scss';
export const dataTableRowDefinition = {
    baseName: 'data-table-row',
    template: dataTableRowComponentTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonDataTableRow = DataTableRowComponent.compose(dataTableRowDefinition);
